export default __webpack_public_path__ + "static/media/screen1.606f0a0d.png";